import { render, staticRenderFns } from "./Panelbox.vue?vue&type=template&id=bdf622f8&"
import script from "./Panelbox.vue?vue&type=script&lang=js&"
export * from "./Panelbox.vue?vue&type=script&lang=js&"
import style0 from "./Panelbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports